import { success } from '@goodt-common/utils';
/* import { ModelError } from './errors/ModelError'; */

export class ModelValidator {
    validate(model) {
        /*
         * return fail(ModelError.createFromErrors([ new ValidationError(message, data) ]));
         */
        return success(true);
    }
}
